<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2 v-show="!trash">Locations</h2>
        		<h2 v-show="trash">Locations - Trash</h2>
			</b-col>
		</div>
		<div class="card">
			<div class="card-body">
				<b-row>
					<b-container fluid>
						<div class="row">

							<b-col lg="4" class="my-1">
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<b-form-input v-model="filter" placeholder="Search" />
										<b-btn class="brad-0" :disabled="!filter" @click="filter = ''">Clear</b-btn>
									</div>
								</div>
							</b-col>

							<b-col v-show="view" lg="3" class="my-1">
                				<b-dropdown id="ddown1" :text="dpdt">
                  					<b-dropdown-item @click="trashLocation()">Active</b-dropdown-item>
                  					<b-dropdown-item @click="trashLocation()">Trash</b-dropdown-item>
                				</b-dropdown>
              				</b-col>
							<!-- :disabled="!insert_data" -->
							<b-col lg="5" md="6" xs="12">
								<b-button v-if="role==='super_admin' || role==='operations_manager'" variant="primary" class="active mb-3 pull-right" @click="showNewLocationModal">Add Location</b-button>
							</b-col>
						</div>

						<b-row v-if="loadingData">
							<b-col cols="12" sm="12" md="12" lg="12">
								<p class="text-center">
									<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
								</p>
							</b-col>
						</b-row>

						<b-table  class="animated fadeIn"
							v-else striped hover bordered show-empty
							stacked="md"
							:current-page="currentPage"
							:per-page="perPage"
							:filter="filter"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
							:items="items"
							:fields="fields"
							@filtered="onFiltered"
						  	@row-clicked="rowClicked"
 						>
						</b-table>
						<!-- User Interface controls -->
						<b-row>
							<b-col lg="2" md="2" sm="12" class="my-1 pull-left">
								<div class="input-group mb-3">
									<div class="input-group-prepend"> </div>
									<b-select :options="pageOptions" v-model="perPage" />
								</div>
							</b-col>
							<b-col lg="10" md="10" sm="12" class="my-1 pull-right">
								<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
							</b-col>
						</b-row>
					</b-container>
				</b-row>
			</div>
		</div>
		<!-- New EModal-->
		<b-modal title="New Location" ref="newLocationModal" v-model="newLocations" hide-header-close no-close-on-backdrop no-close-on-esc>
			<b-row>
				<b-col cols="12">
					<!-- Added by Carlos Rondon 14/02/2019 trucking company-->
					<b-form-group :label-cols="4" id="L3" label="Is this location owned, operated, and solely used by your energy company?" label-for="CompanyTypeID" horizontal>
						<!--<b-form-select id="CompanyTypeID" v-model="model.company_type" :options="companyselect" >
							 <template slot="first"><option :value="null" disabled>-- select comapny type --</option></template>
						</b-form-select> -->
						<b-form-checkbox v-if="role ==='super_admin' || role ==='operations_manager'"
                  				id="checkbox"
								class="custom-checkboxes"
                      			style="margin-top: 43px;"
								v-model="model.company_type"
								@change="clear()"
              			></b-form-checkbox>	
						<b-form-checkbox v-else
                  				id="checkbox"
								class="custom-checkboxes"
                      			style="margin-top: 43px;"
								v-model="model.company_type"
								disabled
              			></b-form-checkbox>	
					</b-form-group>	
					<b-form-group v-if="role ==='super_admin' && model.company_type && energycompanyselect.length > 0 " :label-cols="4" id="L4" label="Energy Company" label-for="EnergyCompanyID" horizontal>
						<b-form-select id="EnergyCompanyID" v-model="model.energy_company_id" :options="energycompanyselect" @input="select_energy_company()" />
					</b-form-group>					
					<!-- End Added -->
					<b-form-group :label-cols="4" id="L4" label="Location Type" label-for="LocationTypeID" horizontal>
						<b-form-select v-if="role ==='super_admin' || role ==='operations_manager'" id="LocationTypeID" v-model="model.location_types_id" :options="locationselect" @input="select_location_type()" />
						<b-form-select v-else id="LocationTypeID" v-model="model.location_types_id" :options="locationselect" disabled/>
					</b-form-group>
					<b-form-group v-if="fluidtypeselect.length > 0" :label-cols="4" id="L4" label="Fluid Type" label-for="FluidTypeID" horizontal>
						<b-form-checkbox-group class="custom-checkboxes" :options="fluidtypeselect" name="Checkboxes" plain v-model="model.fluid_type_id" @input="fluidTypeChange"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="fluidAllSelected" :indeterminate="indeterminate" aria-describedby="" aria-controls="" plain @change="fluidToggleAll">
							{{ fluidAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>
					<!-- Added by Carlos Rondon 14/02/2019 trucking company 
					<b-form-group v-if="model.company_type=='Trucking Company' & truckingcompanyselect.length > 0 & (location_type_name.toLowerCase() == 'loads' || location_type_name.toLowerCase() == 'load')" :label-cols="4" id="TC4" label="Trucking  Companies" label-for="TcID" horizontal>
						<b-form-checkbox-group class="custom-checkboxes" :options="truckingcompanyselect" name="Checkboxes3" plain v-model="model.trucking_company_id" @input="truckingcompanyTypeChange"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="truckingcompanyAllSelected" :indeterminate="indeterminate" aria-describedby="" aria-controls="" plain @change="truckingcompanyToggleAll">
							{{ truckingcompanyAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group> -->
					<!-- End Added -->

					<b-form-group :label-cols="4" id="L1" label="Location Name" label-for="locationname" horizontal>
						<b-form-input id="locationname" type="text" v-model="model.legal_location">
						</b-form-input>
					</b-form-group>
					<b-form-group :label-cols="4" id="L1" label="Location Isolera Name" label-for="isolera_location_name" horizontal>
						<b-form-input id="isolera_location_name" type="text" v-model="model.isolera_location_name">
						</b-form-input>
					</b-form-group>
					<b-form-group :label-cols="4" id="L2" label="LSD" label-for="lsd" horizontal>
						<b-form-input id="lsd" type="text" v-model="model.lsd">
						</b-form-input>
					</b-form-group>
					<b-form-group :label-cols="4" id="L4" label="Latitude" label-for="latitude" horizontal>
						<b-form-input id="latitude" type="number" v-model="model.latitude" @blur.native="coordsBlur('latitude')" >
						</b-form-input>
					</b-form-group>
					<b-form-group :label-cols="4" id="L3" label="Longitude" label-for="longitude" horizontal>
						<b-form-input id="longitude" type="number" v-model="model.longitude" @blur.native="coordsBlur('longitude')" >
						</b-form-input>
					</b-form-group>
					<b-form-group v-if="location_type_name == 'Load'" :label-cols="4" id="L5" label="Battery Code" label-for="battery_code" horizontal>
						<b-form-input id="battery_code" type="text" v-model="model.battery_code">
						</b-form-input>
					</b-form-group>
					<!-- Terminal -->
					<b-form-group v-if="location_type_name == 'Unload'" :label-cols="4" id="L11" label="Terminal" label-for="terminal_id" horizontal>
						<b-form-select value-field="id" text-field="name" id="terminal_id" type="text" v-model="model.terminal_id"  :options="terminalselect">
							<template slot="first"><option :value="null">-- select terminal --</option></template>
						</b-form-select>
					</b-form-group>
					<b-form-group v-if="location_type_name == 'Unload'" :label-cols="4" id="L6" label="Terminal Code" label-for="terminal_code" horizontal>
						<b-form-input id="terminal_code" type="text" v-model="model.terminal_code">
						</b-form-input>
					</b-form-group>

					<b-form-group v-if="location_type_name == 'Load'" :label-cols="4" id="L7" label="Invoice Code" label-for="invoice_code" horizontal>
						<b-form-input id="invoice_code" type="text" v-model="model.invoice_code">
						</b-form-input>
					</b-form-group>
					<!-- UWI -->
					<b-form-group v-if="location_type_name == 'Load'" :label-cols="4" id="L8" label="Uwi" label-for="uwi" horizontal>
						<b-btn  v-on:click="adduwi()" size="sm" variant="primary" class="pull-left">Add Uwi</b-btn>
					</b-form-group>
					<b-card v-if="location_type_name == 'Load' && model.uwi.length>0" title="" class="p-0 m-0 mb-3">
						<b-table striped show-empty empty-text="No UWI have been added"
							:fields = "[{key: 'delete', label: ' '}, {key: 'name', label: 'UWI Name'}, {key: 'cost_code', label: 'Cost Code'}, {key: 'percentage', label: 'Percentage'}]" 
							:items="model.uwi" stacked="sm" outlined small>
							<template slot="delete" slot-scope="item">
								<b-btn v-b-tooltip.hover title="Delete" v-on:click="removeuwi(item.index)" size="sm" class="pull-right"><i class="icon-close"></i></b-btn>
							</template>
							<template slot="name" slot-scope="item">
								<b-form-input size="sm" id="name" v-model="model.uwi[item.index].name" /> 
							</template>
							<template slot="cost_code" slot-scope="item">
								<b-form-input size="sm" id="cost_code" v-model="model.uwi[item.index].cost_code" type="text" />
							</template>
							<template slot="percentage" slot-scope="item">
								<b-form-input size="sm" id="percentage" v-model="model.uwi[item.index].percentage" type="text" @keydown.native="myOnlyNumber($event, 'percentage')"/>
							</template>
						</b-table>
						<!-- <b-row>
							<b-col sm="12">
								<b-btn  v-on:click="adduwi()" size="sm" variant="primary" class="pull-right">Add Uwi</b-btn>
							</b-col>
						</b-row>-->
					</b-card>
					<!-- End UWI -->

					<b-form-group v-if="location_type_name == 'Load'" :label-cols="4" id="L9" label="Contact Name" label-for="contact_name" horizontal>
						<b-form-input id="contact_name" type="text" v-model="model.contact_name">
						</b-form-input>
					</b-form-group> 
					<!-- Operating Areas-->
					<b-form-group v-if="operationareaselect.length > 0" :label-cols="4" id="L10" label="Operating Areas" label-for="operationAreasID" horizontal>
						<b-form-checkbox-group class="custom-checkboxes" :options="operationareaselect" name="Checkboxes2" plain v-model="model.operation_area_id" @input="operationAreaChange"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="oaAllSelected" :indeterminate="indeterminateOA" aria-describedby="" aria-controls="" plain @change="OAToggleAll">
							{{ oaAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>
					<!-- Agreements -->
					<b-form-group v-if="agreements.length > 0 && model.company_type" :label-cols="4" id="L11" label="Agreements" label-for="agrrementsID" horizontal>
						<b-form-checkbox-group class="custom-checkboxes" :options="agreements" name="Checkboxes2" plain v-model="model.agreement_id" @input="agreeChange"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="agreeAllSelected" :indeterminate="indeterminateAgree" aria-describedby="" aria-controls="" plain @change="agreeToggleAll">
							{{ agreeAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>
					<!-- Assinging All Drivers
					<b-form-group 	v-if="model.operation_area_id.length > 0"
									horizontal
									id="L11"
                					:label-cols="4"
                					label-size="md"
                					label=""
                					label-for="q1">
						<b-form-checkbox id="q1"
									style="margin-top: 15px;"
									:label-cols="6"
                     				v-model="model.alldrivers"
                     				value="accepted"
									aria-describedby=""
									aria-controls=""
									plain
                     				unchecked-value="not_accepted">  Would you like assign all drivers to this location?

    					</b-form-checkbox>
					</b-form-group>-->
				</b-col>
			</b-row>
			<div slot="modal-footer" class="w-100">
				<b-btn size="md" variant="secondary" @click="hideNewLocationModal" class="float-left">Cancel</b-btn>
				<b-btn v-if="savebtn" size="md" variant="primary" @click="saveLocations(model)" class="float-right">Save</b-btn>
				<b-btn v-else size="md" disabled variant="primary" class="float-right">Save</b-btn>
			</div>
		</b-modal>
		<!-- End New  Modal-->
		<!-- Table Config-->
		<b-modal title="Config Table" v-model="configTable" ok-variant="primary">
			<b-row>
				<b-col cols="12">
					<b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
						<b-form-checkbox value="id" :disabled="true" @change="actionField('legal_location')">Legal Location</b-form-checkbox>
						<b-form-checkbox value="name" :disabled="true" @change="actionField('longitude')">Longitude</b-form-checkbox>
						<b-form-checkbox value="status" :disabled="true" @change="actionField('latitude')">Latitude</b-form-checkbox>
						<b-form-checkbox value="status" :disabled="true" @change="actionField('location_type')">Location Type</b-form-checkbox>
					</b-form-checkbox-group>
				</b-col>
			</b-row>
		</b-modal>
		<!-- Table Config-->
	</div>
</template>

<script>
	//import locations_service from './locations_service'
	// Agregado por Carlos Rondon
	import Vue from 'vue'
	import vSelect from 'vue-select'
	import locations_service from './locations_service'
	import ec_service from '../energy_companies/ec_service'

	export default {
		name: 'm_locations',
		created: function() {
			this.getAll()
			localStorage.removeItem("haulsaPage");
			localStorage.removeItem("targetsaPage");
			localStorage.removeItem("ftPage");
			localStorage.removeItem("targetPage");
			localStorage.removeItem("tpPage");
			localStorage.removeItem("oasaPage");
			localStorage.removeItem("oaPage");
			localStorage.removeItem("reportPage");
			localStorage.removeItem("rolesPage");
			localStorage.removeItem("servicePage");
			localStorage.removeItem("truckPage");
			localStorage.removeItem("tcPage");
			localStorage.removeItem("taPage");
			localStorage.removeItem("tasaPage");
			localStorage.removeItem("userPage");
			if (!localStorage.locationPage) {
					localStorage.locationPage = 0;
			}
		},
		data() {
			return {
				isSuperAnalyst		: false,
				trash				: false,
				dpdt				: "Active",
				indeterminateOA		: false,
				indeterminate		: false,
				oaAllSelected		: false,
				fluidAllSelected	: false,
				insert_data			: null,
				newLocations		: false,
				items				: [],
				loadingData			: true,
				currentPage			: parseInt(localStorage.locationPage),
				perPage				: 25,
				totalRows			: 0,
				pageOptions			: [25, 50, 100],
				sortBy				: 'legal_location',
				sortDesc			: false,
				fields: [
				{
					key: 'id',
					label: 'ID',
					sortable: true
				},
				{
					key: 'legal_location',
					label: 'Location Name',
					sortable: true
				},
				{
					key: 'lsd',
					label: 'LSD',
					sortable: true
				}, 
				{
					key: 'latitude',
					label: 'Latitude',
					// formatter: (value) => { return Number(parseFloat(value).toFixed(6)).toLocaleString('en-IN', {minimumFractionDigits: 6, maximumFractionDigits: 6})}
				},
				{
					key: 'longitude',
					label: 'Longitude',
					// formatter: (value) => { return Number(parseFloat(value).toFixed(6)).toLocaleString('en-IN', {minimumFractionDigits: 6, maximumFractionDigits: 6})}
				}, 
				{
					key: 'location_type',
					label: 'Location Type',
					sortable: true
				}],
				filter				: null,
				configTable			: false,
				selectedItems		: ['id', 'name', 'status'],
				locationselect		: [],
				energycompanyselect	: [],
				fluidtypeselect		: [],
				operationareaselect	: [],
				location_type_name	:'',
				model: {
					id					: null,
					legal_location		: '',
					longitude			: '',
					latitude			: '',
					location_types_id	: '',
					fluid_type_id		: [],
					energy_company_id	: '',
					energy_company_name	: '',
					operation_area_id	: [],
					lsd					: '',
					alldrivers			: 'not_accepted',
					// Created by Carlos Rondon 14/02/2019 trucking company
					company_type		: false,
					trucking_company_id	: [],
					invoice_code		:'',
					uwi					:[],
					contact_name 		:'',
					// End Created
					isolera_location_name:'',
					battery_code		:'',
					terminal_code		:'',
					terminal_id			:null,
					agreement_id		: [],
				},
				// Google Map API
				zoom: 10,
				mapTypeId: 'roadmap',
				center: {
					"lat": 50.995457775379,
					"lng": -113.97837946982
				},
				start						: null,
				role						:'',
				view						:true,
				view1						:true,
				savebtn						:true,
				energy_company_id 			:null,
				// Added by Carlos Rondon 
				//companyselect: ['Energy Company','Trucking Company'],
				truckingcompanyselect		: [],
				truckingcompanyAllSelected	: false,
				terminalselect				: [],
				percentage					: '',
				resp_al 					: [],
				resp_aall 					: [],
				// -------------------
				agreements					: [],
				indeterminateAgree			: false,
				agreeAllSelected			: false,
				// End Added
			}
		},
		computed: {
			sortOptions() {
				// Create an options list from our fields
				return this.fieldsTh
					.filter(f => f.sortable)
					.map(f => {
						return {
							text: f.label,
							value: f.key
						}
					})
			}
		},
		mounted() {
			this.geolocate();
		},
		methods: {
			coordsBlur(variableName) {
				if(this.model[variableName] !== undefined) {
					let x = String(this.model[variableName]).split(".")
					if(x.length == 1 && x[0].length == 0) {
						this.model[variableName] = '0.00'
					} else if(x.length == 1) {
						this.model[variableName] = this.model[variableName] + '.00'
					} else {
						this.model[variableName] = x[0] + "." + x[1]
						this.model[variableName] = parseFloat(parseFloat(String(this.model[variableName])))
					}
				}
			},
			clear() {
				if (this.model.company_type==true) {
					this.operationareaselect 		= []
					this.agreements 				= []
				} else {
					this.operationareaselect 		= this.resp_al
					this.agreements 				= this.resp_aall
				}
				//this.operationareaselect 		= []
				this.model.operation_area_id 	= []
				this.model.agreement_id 	    = []
				this.model.location_types_id	= ''
				this.model.fluid_type_id		= []
				this.location_type_name			= ''
				this.indeterminateAgree			= false
				this.agreeAllSelected			= false
      		},
			trashLocation() {
				this.trash = !this.trash
				this.dpdt = this.trash ? 'Trash' : 'Active'
				this.getAll()
				this.loadingData = true
      		},
			fluidToggleAll(checked) {
				this.model.fluid_type_id = checked ? this.fluidtypeselect.map(item => {
					return item.value
				}) : []
			},
			OAToggleAll(checked) {
				this.model.operation_area_id = checked ? this.operationareaselect.map(item => {
					return item.value
				}) : []
			},
			fluidTypeChange() {
				if (this.model.fluid_type_id.length === 0) {
					this.indeterminate = false
					this.fluidAllSelected = false
				} else if (this.model.fluid_type_id.length === this.fluidtypeselect.length) {
					this.indeterminate = false
					this.fluidAllSelected = true
				} else {
					this.indeterminate = true
					this.fluidAllSelected = false
				}
			},
			// Added by Carlos Rondon 14/02/2019 trucking company
			truckingcompanyTypeChange() {
				if (this.model.trucking_company_id.length === 0) {
					this.indeterminate = false
					this.truckingcompanyAllSelected = false
				} else if (this.model.trucking_company_id.length === this.truckingcompanyselect.length) {
					this.indeterminate = false
					this.truckingcompanyAllSelected = true
				} else {
					this.indeterminate = true
					this.truckingcompanyAllSelected = false
				}
			},
			truckingcompanyToggleAll(checked) {
				this.model.trucking_company_id = checked ? this.truckingcompanyselect.map(item => {
					return item.value
				}) : []
			},
			// End Added
			operationAreaChange() {
				if (this.model.operation_area_id.length === 0) {
					this.indeterminateOA = false
					this.oaAllSelected = false
				} else if (this.model.operation_area_id.length === this.operationareaselect.length) {
					this.indeterminateOA = false
					this.oaAllSelected = true
				} else {
					this.indeterminateOA = true
					this.oaAllSelected = false
				}
			},
			select_energy_company() {
				//let location_types = this.insert_data.location_types
				//let current_location_type_index = location_types.map(o => o.id).indexOf(this.model.location_types_id)
				//if (current_location_type_index > -1) {
					let energycompanies = this.insert_data.energy_companies
					let energy_company_index = energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
					if (energy_company_index > -1) {
						this.model.energy_company_name =  energycompanies[energy_company_index].company_name
						let operatingareas = energycompanies[energy_company_index].operating_areas
						let agreements = energycompanies[energy_company_index].agreements
						if (Array.isArray(operatingareas)) {
							this.operationareaselect = operatingareas.map((item) => {
								return {
									'value': item.id,
									'text': item.name
								}
							})
							this.model.operation_area_id 	= []
							this.resp_al					= this.operationareaselect
							this.agreements 				= agreements
							this.resp_aall					= this.agreements
						} else {
							this.operationareaselect 		= []
							this.model.operation_area_id 	= []
							this.resp_al					= this.operationareaselect
							this.agreements 				= []
							this.resp_aall					= this.agreements
						}
					}
				//}
			},
			select_location_type() {

				// this.model.energy_company_id 	= ''
				// this.operationareaselect 		= []
				let location_types 				= this.insert_data.location_types

				let current_location_type_index = location_types.map(o => o.id).indexOf(this.model.location_types_id)
				if (current_location_type_index > -1) {
					this.location_type_name = location_types[current_location_type_index].name
					/*if (!this.model.company_type) {
						let operatingareas = this.insert_data.operating_areas
						if (Array.isArray(operatingareas)) {
							this.operationareaselect = operatingareas.map((item) => {
								return {
									'value': item.id,
									'text': item.name
								}
							})
							this.model.operation_area_id = []
						} else {
							this.operationareaselect = []
							this.model.operation_area_id = []
						}
						console.log(this.operationareaselect)
					}
					
					if (this.role =='super_admin') {
							if(this.location_type_name.toLowerCase() === 'loads' || this.location_type_name.toLowerCase() === 'load') {
							let energycompanies = location_types[current_location_type_index].energy_company
							this.energycompanyselect = energycompanies.map((item) => {
								return {
								'value': item.id,
								'text': item.company_name
								}
							})
							} else {
							let energycompanies = location_types[current_location_type_index].energy_company
							let energy_company_index = energycompanies.map(o => o.id).indexOf(0)

							let operatingareas = energycompanies[energy_company_index].operating_areas
							if (Array.isArray(operatingareas)) {
								this.operationareaselect = operatingareas.map((item) => {
									return {
									'value': item.id,
									'text': item.name
									}
								})
								this.model.operation_area_id = []
								this.energycompanyselect = []
							} else {
								this.operationareaselect = []
								this.model.operation_area_id = []
							}
						}
					}
					if (this.role =='super_analyst') {
							let energycompanies = location_types[current_location_type_index].energy_company
							let operatingareas = energycompanies[0].operating_areas
							if (Array.isArray(operatingareas)) {
								this.operationareaselect = operatingareas.map((item) => {
									return {
									'value': item.id,
									'text': item.name
									}
								})
								this.model.operation_area_id = []
								this.energycompanyselect = []
							} else {
								this.operationareaselect = []
								this.model.operation_area_id = []
							}
					} */
					if (location_types[current_location_type_index].fluid_types) {
						let fluidtypes = location_types[current_location_type_index].fluid_types
						this.fluidtypeselect = fluidtypes.map((item) => {
							return {
								'value': item.id,
								'text': item.name
							}
						})
					} else {
						this.fluidtypeselect = []
						this.model.fluid_type_id = []
					}
				}
			},
			rowClicked(row) {
				localStorage.locationPage = this.currentPage;
				if(!this.trash) {
					localStorage.setItem('xyz', row.id)
					this.$router.push('/location/' + row.id + '/')
				} else {
					this.restoreLocation(row.id)
				}
			},
			clicked(e) {
				this.start = {
					latLng: e.latLng
				}
				this.model.longitude = e.latLng.lng()
				this.model.latitude = e.latLng.lat()

			},
			geolocate() {
				navigator.geolocation.getCurrentPosition(position => {
					this.center = {
						lat: position.coords.latitude,
						lng: position.coords.longitude
					}
				})
			},
			actionField(option) {
				var fieldsThLength = this.fieldsTh.length
				var fieldIsActive = false
				for (var i = 0; i <= fieldsThLength; i++) {
					fieldIsActive = true
					try {
						if (this.fieldsTh[i].key === option || this.fieldsTh[i] === option) {
							this.fieldsTh.splice(i, 1)
							fieldIsActive = false
							break
						}
					} catch (err) {
						var position = this.fields.indexOf(option)
						this.fieldsTh.splice(position, 0, option)
					}
				}
			},
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.totalRows = filteredItems.length
				if (localStorage.getItem("locationPage") === null) {
					this.currentPage = 0
					localStorage.setItem('locationPage', 0)
				} else {
					this.currentPage = parseInt(localStorage.locationPage)
				}
				
			},
			hideNewLocationModal() {
				this.$refs.newLocationModal.hide()
			},
			showNewLocationModal() {

				this.savebtn=true
				this.model = {
					legal_location		: '',
					longitude			: '',
					latitude			: '',
					location_types_id	: '',
					fluid_type_id		: [],
					energy_company_id	: '',
					energy_company_name	: '',
					operation_area_id	: [],
					lsd					: '',
					terminal_code		: '',
					alldrivers			: 'not_accepted',
					// Created by Carlos Rondon 14/02/2019 trucking company
					company_type		: false,
					trucking_company_id	: [],
					invoice_code		:'',
					uwi					:[],
					contact_name 		:'',
					// End Created
					isolera_location_name:'',
					battery_code		:'',
					terminal_code		:'',
					terminal_id			: null,
					agreement_id		: [],
				}
				// this.energycompanyselect = []
				this.fluidtypeselect = []
				this.operationareaselect = []
				this.newLocations = true
				this.location_type_name =''
				this.agreements = []
				this.indeterminateAgree			= false
				this.agreeAllSelected			= false
				this.resp_aall = []
				this.resp_al = []
				// -----
				if (this.role =='operations_manager') {
					this.model.energy_company_id 	= this.energy_company_id
					this.select_energy_company()
					this.operationareaselect = []
					//this.model.location_types_id	= 1   // load Location
					//this.select_location_type()
					//this.model.company_type			= true
				}
				// -----
			},
			okToSave() {
				if (this.model.location_types_id === undefined || this.model.location_types_id.length == 0) {
					this.$swal('Alert!', 'Location Type not selected', 'warning')
					return false
				} else if (this.model.legal_location === undefined || this.model.legal_location.length == 0) {
					this.$swal('Alert!', 'Location Name can not be empty', 'warning')
					return false
				
				} else if (this.model.longitude === null || String(this.model.longitude).length == 0) {
					this.$swal('Alert!', 'Longitude can not be empty', 'warning')
					return false
				} else if (this.model.latitude === null || String(this.model.latitude).length == 0) {
					this.$swal('Alert!', 'Latitude can not be empty', 'warning')
					return false

				// Added by Carlos Rondon 14/02/2019 trucking company

				}

				if(this.model.uwi.length>0){
					let length = this.model.uwi.length;
					for (var i = 0; i < length; i++) {
						if(this.model.uwi[i].name == null || this.model.uwi[i].name == '') {
							this.$swal('Alert!', 'Uwi name cannot be empty', 'warning')
							return false
						} else if(this.model.uwi[i].cost_code	== null || this.model.uwi[i].cost_code	== '') {
							this.$swal('Alert!', 'Uwi Cost Code cannot be empty', 'warning')
							return false
						} else if(this.model.uwi[i].percentage	== null || this.model.uwi[i].percentage	== '') {
							this.$swal('Alert!', 'Uwi Percentage cannot be empty', 'warning')
							return false 
						}			
					} 
				} 
/*
				if (this.role =='super_admin') {
					if (this.model.company_type === undefined || this.model.company_type.length == 0) {
						this.$swal('Alert!', 'Company Type can not be empty', 'warning')
						return false
					} else if (this.model.company_type === 'Energy Company') {
						if ((this.model.energy_company_id === undefined || this.model.energy_company_id.length == 0) && (this.location_type_name.toLowerCase() == 'loads' || this.location_type_name.toLowerCase() == 'load')) {
							this.$swal('Alert!', 'Energy Company not selected', 'warning')
							return false
						}
					} else if (this.model.company_type === 'Trucking Company') {
						if ((this.model.trucking_company_id === undefined || this.model.trucking_company_id.length == 0) && (this.location_type_name.toLowerCase() == 'loads' || this.location_type_name.toLowerCase() == 'load')) {
						this.$swal('Alert!', 'Trucking Company not selected', 'warning')
						return false
						}
					}
				}   */
				 // End Added
				return true
			},
			saveLocations(model) {
			/*	if (this.role =='super_analyst'){
					this.model.energy_company_id 	= this.energy_company_id
					this.model.company_type			= 'Energy Company'
					this.model.trucking_company_id	=[]
				}  */
				this.savebtn=false
				if (!this.okToSave()) {
					this.savebtn=true
					return
				}
				model = {
					legal_location			: model.legal_location,
					isolera_location_name	: model.isolera_location_name,
					energy_company_id		: model.energy_company_id,
					energy_company_name		: model.energy_company_name,
					longitude				: parseFloat(parseFloat(String(model.longitude))),
					latitude				: parseFloat(parseFloat(String(model.latitude))),
					location_types_id		: model.location_types_id,
					fluid_types: model.fluid_type_id.map(item => {
						return {
							id: String(item)
						}
					}),
					operating_areas			: model.operation_area_id.map(item => {
						return {
							id: String(item)
						}
					}),
					lsd						: model.lsd,
					terminal_id				: model.terminal_id,
					terminal_code			: model.terminal_code,
					battery_code			: model.battery_code,
					alldrivers				: model.alldrivers,
					// Added by Carlos Rondon 14/02/2019 trucking company
					company_type			: model.company_type,
					trucking_companies		: model.trucking_company_id,
					invoice_code			:model.invoice_code,
					uwi						:model.uwi,
					contact_name 			:model.contact_name,
					agreements	     		: model.agreement_id.map(item => {
						return {
							id: String(item)
						}
					}),
					// End Added
				}
				// this.model.location_types_id = this.selected.value
				locations_service.save(model)
					.then(data => {
						Vue.swal(data[0], data[1], data[0])
						// this.location_type_name=''
						if (data[0] == 'success') {
							this.newLocations = false
							this.start = null
							this.getAll()
							this.savebtn=true
						} else {
							this.savebtn=true
						}
					})
					.catch(error => {
						Vue.swal('Error', 'Server not response. ' + error, 'error')
						this.savebtn=true
					})
					
			},
			getAll() {
				this.loadingData = true
				locations_service.getAll()
					.then(data => {
						if (data[0] == 'success') {
							this.items 			= data[1].filter(item => item.status_id == (!this.trash ? 1 : 2))
							this.insert_data 	= data[2]
							let location 		= this.insert_data.location_types
							this.locationselect = location.map((item) => {
								return {
									'value': item.id,
									'text': item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()
								}
							})
							// Added by Carlos Rondon 
							let energycompanies = this.insert_data.energy_companies
							console.log(energycompanies)
							this.energycompanyselect = energycompanies.map((item) => {
								return {
								'value': item.id,
								'text': item.company_name
								}
							})
							//
							let trucking_companies_map = this.insert_data.trucking_companies
							if (trucking_companies_map.length !=0) {
								this.truckingcompanyselect = trucking_companies_map.map((item) => {
									return {
										'value': item.id,
										'text': item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()
									}
							})
							}
							this.terminalselect = this.insert_data.terminals
							// End Added
							this.role = data[3]
							if (this.role =='super_admin') {
								this.view=true
								this.view1=true

							} else if (this.role =='super_analyst') {
								this.energy_company_id = data[4]
								this.view=true
								this.view1=false
								//this.companyselect= ['Energy Company']
								//this.model.company_type = 'Energy Company'
							} else if (this.role =='analyst' || this.role =='marketing_accountant') {
								//this.companyselect= ['Energy Company']
								//this.model.company_type = 'Energy Company'
                  				this.view=false
								this.view1=false
							} else if (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
                  				this.view=false
								this.view1=false
							} else if (this.role =='operations_manager') {
								this.energy_company_id = data[4]
                  				this.view=false
								this.view1=false
							}
						} else {
							this.locationselect = []
							this.items = []
							this.$swal(data[0], data[1], data[0])
						}
						this.loadingData = false
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			restoreLocation(id) {
					this.$swal({
						title: 'Please, confirm',
						text: "Are you sure to restore this Location",
						type: 'question',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Yes',
						reverseButtons: true
					}).then((result) => {
						if (result.value) {
							locations_service.restore(id)
								.then(data => {
									this.$swal(data[0], data[1], data[0])
									if (data[0] == 'success') {
										this.filter = ''
										this.trash = false
										this.dpdt = this.trash ? 'Trash' : 'Active'
										this.getAll()
										this.loadingData = true
									}
								})
								.catch(error => {
									this.$swal('Error', 'Server not response. ' + error, 'error')
								})
						}
					})
				},
				adduwi() {
					let uwi	= {
						name		: null,
						cost_code	: null,
						percentage	: null,
					}
					this.model.uwi.push(uwi)

				},
				removeuwi(uwi) {
					this.model.uwi.splice(uwi,1)
				},
					myOnlyNumber(evt, variableName) {
					let dotPosition = this[variableName].indexOf(".")
					let hasDot = dotPosition > -1
					let length = this[variableName].length
					this.isNumber(evt, hasDot, dotPosition, length)
				},
				isNumber: function(evt, hasDot, dotPosition, length) {
					evt = (evt) ? evt : window.event;
					var charCode = (evt.which) ? evt.which : evt.keyCode;
					if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
					// if (charCode <= 31 || charCode == 37 || charCode == 39 || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190))) {
						let selectionStart = evt.target.selectionStart;
						let selectionEnd = evt.target.selectionEnd;
						if ((hasDot && selectionEnd > dotPosition && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
							evt.preventDefault();
						} else {
							return true
						}
					} else {
						evt.preventDefault();
					}
				},
			agreeToggleAll(checked) {
				this.model.agreement_id = checked ? this.agreements.map(item => {
					return item.value
				}) : []
			},
			agreeChange() {
				if (this.model.agreement_id.length === 0) {
					this.indeterminateAgree = false
					this.agreeAllSelected = false
				} else if (this.model.agreement_id.length === this.agreements.length) {
					this.indeterminateAgree = false
					this.agreeAllSelected = true
				} else {
					this.indeterminateAgree = true
					this.agreeAllSelected = false
				}
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/locations/m_locations.vue